const BeasleyLogo = (props) => {
  return (
    <img src="/static/logos/Beasley-Creative.png" width={props.width} />
  )
};

export default BeasleyLogo;
